import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import OverlayComponent from "../components/PeopleOverlay.jsx";

const SELECTORS = {
  item: "[data-people-item]",
  trigger: "[data-people-trigger]",
  name: ".b-people__item-name",
  jobTitle: ".b-people__item-position",
  picture: ".b-people__item-picture",
  location: "[data-people-location]",
  bio: "[data-people-bio]",
};

export default class People extends BaseModule {
  init() {
    this.items = this.collectItems();

    if (!this.items.length) {
      return;
    }

    this.mountTarget = document.createElement("div");
    this.mountTarget.className = "b-people__overlay-root";
    this.el.appendChild(this.mountTarget);

    this.isOpen = false;
    this.activeItem = null;

    this.handleClose = this.handleClose.bind(this);
    this.attachTriggerListeners();
    this.render();
  }

  collectItems() {
    const nodes = Array.from(this.el.querySelectorAll(SELECTORS.item));

    return nodes
      .map((node, index) => {
        const trigger = node.querySelector(SELECTORS.trigger);

        if (!trigger) {
          return null;
        }

        const nameEl = node.querySelector(SELECTORS.name);
        const jobEl = node.querySelector(SELECTORS.jobTitle);
        const pictureEl = node.querySelector(SELECTORS.picture);
        const locationEl = node.querySelector(SELECTORS.location);
        const bioEl = node.querySelector(SELECTORS.bio);

        return {
          id: node.id || `people-item-${index}`,
          trigger,
          name: nameEl ? nameEl.textContent.trim() : "",
          jobTitle: jobEl ? jobEl.textContent.trim() : "",
          imageHTML: pictureEl ? pictureEl.innerHTML.trim() : "",
          locationHTML: locationEl ? locationEl.innerHTML.trim() : "",
          bioHTML: bioEl ? bioEl.innerHTML.trim() : "",
        };
      })
      .filter(Boolean);
  }

  attachTriggerListeners() {
    this.items.forEach((item) => {
      if (!item.trigger) {
        return;
      }

      const handler = (event) => this.handleTriggerClick(event, item);
      item.trigger.addEventListener("click", handler);
      item.triggerHandler = handler;
    });
  }

  detachTriggerListeners() {
    this.items.forEach((item) => {
      if (item.trigger && item.triggerHandler) {
        item.trigger.removeEventListener("click", item.triggerHandler);
        item.triggerHandler = null;
      }
    });
  }

  handleTriggerClick(event, item) {
    event.preventDefault();
    this.activeItem = item;
    this.isOpen = true;
    this.render();
  }

  handleClose() {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.activeItem = null;
    this.render();
  }

  render() {
    if (!this.mountTarget) {
      return;
    }

    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.mountTarget);
    }

    this.reactRoot.render(
      createElement(OverlayComponent, {
        isOpen: this.isOpen,
        person: this.activeItem,
        onClose: this.handleClose,
      })
    );
  }

  destroy() {
    this.detachTriggerListeners();

    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }

    if (this.mountTarget) {
      this.mountTarget.remove();
      this.mountTarget = null;
    }

    this.items = [];
    this.activeItem = null;
    this.isOpen = false;
  }
}
